import { render, staticRenderFns } from "./DowntimeReasonView.vue?vue&type=template&id=cc8fa8d2"
import script from "./DowntimeReasonView.vue?vue&type=script&lang=js"
export * from "./DowntimeReasonView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports